__turbopack_context__.v({
  "editActions": "_K3qUq_editActions",
  "editPanel": "_K3qUq_editPanel",
  "itemPrice": "_K3qUq_itemPrice",
  "optionHeader": "_K3qUq_optionHeader",
  "optionLabel": "_K3qUq_optionLabel",
  "participantFieldset": "_K3qUq_participantFieldset",
  "participantItem": "_K3qUq_participantItem",
  "participantLegend": "_K3qUq_participantLegend",
  "participantList": "_K3qUq_participantList",
  "participantName": "_K3qUq_participantName",
  "participantPrice": "_K3qUq_participantPrice",
  "price": "_K3qUq_price",
  "priceBlock": "_K3qUq_priceBlock",
  "sheetContent": "_K3qUq_sheetContent",
});
